import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { faAlignLeft } from '@fortawesome/free-solid-svg-icons/faAlignLeft';
import { faAlignCenter } from '@fortawesome/free-solid-svg-icons/faAlignCenter';
import { faAlignRight } from '@fortawesome/free-solid-svg-icons/faAlignRight';
import { Icon } from '@appcues/sonar';
import { DIRECTIONS } from 'lib/user-preferences';
import { selectUserPreferences } from 'entities/user-preferences/reducer';
import { updateUserPreferences } from 'entities/user-preferences/actions';
import { Container, Label, AlignmentButton } from './styled';

const [LTR] = DIRECTIONS;

const textAlignmentPositions = ['leading', 'center', 'trailing'];
const textAlignmentIcons = [faAlignLeft, faAlignCenter, faAlignRight];

const TextAlignmentPicker = ({ alignment, onClick, direction }) => {
  const [selected, setSelected] = useState(alignment);

  const textAlignmentOptions =
    direction === LTR
      ? textAlignmentPositions
      : textAlignmentPositions.toReversed();

  useEffect(() => {
    setSelected(alignment);
  }, [alignment]);

  const handleClick = position => {
    setSelected(position);
    onClick(position);
  };

  return (
    <Container>
      <Label>Align</Label>

      {textAlignmentOptions.map((position, index) => (
        <AlignmentButton
          key={position}
          onClick={() => handleClick(position)}
          selected={position === selected}
          aria-label={position}
          title={position}
        >
          <Icon icon={textAlignmentIcons[index]} />
        </AlignmentButton>
      ))}
    </Container>
  );
};

TextAlignmentPicker.propTypes = {
  alignment: PropTypes.oneOf(textAlignmentPositions),
  onClick: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.objectOf(PropTypes.func),
  ]),
  direction: PropTypes.oneOf(DIRECTIONS),
};

const mapStateToProps = state => ({
  direction: selectUserPreferences(state).direction,
});

const mapDispatchToProps = {
  onUserPreferencesUpdate: updateUserPreferences,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TextAlignmentPicker);
